module.exports = __webpack_public_path__ + "static/media/neetu.e2aa6ed0.JPG";